module.exports = __webpack_public_path__ + "static/media/u45_premium_contract1.70617b0f.webp";